/**
 * Composable for managing theme-related functionality across different websites.
 * Provides computed properties for current and deferred brand themes.
 *
 * @returns {Object} An object containing theme-related computed properties
 * @property {ComputedRef<string>} currentBrandTheme - The theme of the current website
 * @property {ComputedRef<string>} deferredBrandTheme - The theme of the deferred website
 * @property {ComputedRef<boolean>} isGiorgioArmaniTheme - Indicates if the current website theme is Giorgio Armani
 * @property {ComputedRef<boolean>} isGiorgioArmaniThemeDeferred - Indicates if the deferred website theme is Giorgio Armani
 */
export const useTheme = () => {
  const { currentWebsite, deferredCurrentWebsite } = useWebsite()

  const { getBrandTheme } = useBrandsSettings()

  // Computed property for the current brand theme
  const currentBrandTheme = computed(() => getBrandTheme(currentWebsite.value))

  // Computed property for the deferred brand theme
  const deferredBrandTheme = computed(() =>
    getBrandTheme(deferredCurrentWebsite.value)
  )

  // Computed property to check if the current theme is Giorgio Armani
  const isGiorgioArmaniTheme = computed(
    () => currentBrandTheme.value === 'giorgio-armani'
  )

  // Computed property to check if the deferred theme is Giorgio Armani
  const isGiorgioArmaniThemeDeferred = computed(
    () => deferredBrandTheme.value === 'giorgio-armani'
  )

  return {
    currentBrandTheme,
    deferredBrandTheme,
    isGiorgioArmaniTheme,
    isGiorgioArmaniThemeDeferred,
  }
}
